import React, { PropsWithChildren, useCallback, useState } from 'react';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

interface Props {
  className?: string;
  onZoomClick?: () => void;
}

export const ImageZoom = ({ children, className, onZoomClick }: PropsWithChildren<Props>) => {
  const [isZoomed, setIsZoomed] = useState(false);
  const handleZoomChange = useCallback(shouldZoom => {
    setIsZoomed(shouldZoom);
  }, []);

  const onClick = (e: any) => {
    setIsZoomed(!isZoomed);
    onZoomClick && onZoomClick();
  };

  return (
    <div className={className} onClick={onClick}>
      <ControlledZoom isZoomed={isZoomed} onZoomChange={handleZoomChange}>
        {children}
      </ControlledZoom>
    </div>
  );
};
